// SCRNITM#fx
export default [
  {
    name: 'MyFans',
    path: '/fans',
    meta: {
      permission: 'MB0000086'
    },
    component: () => import(/* webpackChunkName: "fans" */ './Fans.vue')
  },
  {
    name: 'PushMessage',
    path: '/fans/push_message',
    meta: {
      permission: 'MB0000086'
    },
    component: () =>
      import(/* webpackChunkName: "push_message" */ './PushMessage.vue')
  }
]
